import Collapse from '@mui/material/Collapse';
import { TransitionProps } from '@mui/material/transitions';
import { animated, useSpring } from '@react-spring/web';

export default function LeafTransition(props: TransitionProps) {
    const style = useSpring({
        to: {
            opacity: props.in ? 1 : 0,
            transform: `translate3d(${props.in ? 0 : -10}px,0,0)`,
        },
    });

    const AnimatedDiv = animated('div');

    return (
        <AnimatedDiv style={style}>
            <Collapse {...props} />
        </AnimatedDiv>
    );
}
